import getValueFromObjectList from './getValueFromObjectList';

const getAllKeyValues = args => {
  const keyValue = {};
  let tmp;
  let customParameters;

  args.forEach(item => {
    // change getValueFromObjectList: each item used instead of fallback logic
    tmp = getValueFromObjectList([item]);
    // tmp = { property: page_secure, value: false }
    if (tmp) {
      // keyValue = { page_secure: false }
      keyValue[tmp.property] = tmp.value;
      customParameters = { ...customParameters, ...keyValue };
    }
  });

  return customParameters;
};

export default getAllKeyValues;
